<template>
<div>
<div class="name-card">
  <v-card :color="color" ref="card" :dark="dark" :img="cardBgImage">
    <v-responsive v-if="showTopNav">
      <v-layout row justify-space-between class="ma-0">
        <v-flex xs2>
          <v-icon :id="id" @click="deleteEmployee(id)" color="pink">delete</v-icon>
        </v-flex>
        <v-flex xs2 class="text-sm-right">
          <v-icon :id="id" @click="editEmployee(id)">edit</v-icon>
        </v-flex>
      </v-layout>
    </v-responsive>    
    <v-card-text>
      <div class="layout ma-0 align-center" :class="computeCardLayout">
        <v-avatar :size="computeAvatarSize" color="primary">
          <img v-bind:src="avatar.src" v-bind:alt="firstName" v-if="showAvatar">
          <span v-else class="white--text headline">{{ firstName.charAt(0) }}{{ lastName.charAt(0) }}</span>
        </v-avatar>
        <div class="flex" :class="computeTextAlgin">
          <div class="subheading">{{firstName}} {{lastName}}</div>
          <span class="caption">{{role}}</span>
        </div>
      </div>
    </v-card-text>
  </v-card>
  <v-bottom-nav :value="true" color="transparent" :height="64" v-if="showBottomNav">
    <v-dialog
      v-model="showPhone"
      hide-overlay
      width="300"
    >
    <v-btn flat color="teal" slot="activator" value="recent">
      <span>{{'members._phone_'|translate}}</span>
      <v-icon>phone</v-icon>
    </v-btn>
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Numero de Telephone: {{phone}}
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showEntrees"
      hide-overlay
      width="300"
    >
    <v-btn flat color="teal" slot="activator" value="favorites">
      <span>{{'emp._data_'|translate}}</span>
      <v-icon>list</v-icon>
    </v-btn>
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
         {{'emp._total_data_'|translate}} : {{entrees}}
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showToday"
      hide-overlay
      width="300"
    >
    <v-btn flat color="teal" slot="activator" value="nearby">
      <span>{{'dashboard._Today_'|translate}}</span>
      <v-icon>list</v-icon>
    </v-btn>
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
         {{'emp._today_data_'|translate}} : {{todays}}
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-bottom-nav>   
</div>
</div>
</template>

<script>
import { db } from '@/api/firebaseInit';
import firebase from 'firebase';
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
    firstName: {
      type: String,
      default: ''
    },
    lastName: {
      type: String,
      default: ''
    },
    role: {
      type: String,
      default: ''
    },
    phone: {
      type: String,
      default: ''
    },
    entrees: {
      type: Number,
      default: 0
    },
    todays: {
      type: Number,
      default: 0
    },
    avatar: {
      type: Object,
      default: null
    },
    jobTitle: {
      type: String,
      default: ''
    },
    cardBgImage: {
      type: String,
    },
    color: {
      type: String,
      default: ''
    },
    dark: {
      type: Boolean,
      default: false
    },
    bottomNav: {
      type: Boolean,
      default: false
    },    
    topNav: {
      type: Boolean,
      default: true
    },      
    mini: {
      type: Boolean,
      default: false
    }    
  },
  data: () => ({
    showToday: false,
    showEntrees: false,
    showPhone: false
  }),
  
  computed: {
    computeCardLayout () {
      return (this.mini) ? 'row' : 'column';
    },
    computeTextAlgin () {
      return (this.mini) ? 'text-sm-right' : 'text-sm-center';
    },
    computeAvatarSize () {
      return (this.mini) ? '48' : '96';
    },
    showAvatar () {
      return this.avatar !== null && this.avatar.src;
    },

    showBottomNav () {
      return (this.mini === false && this.bottomNav); 
    },

    showTopNav () {
      return (this.mini === false && this.topNav); 
    }
  },

  methods: {
    editEmployee (id) {
      db.collection('Employees').doc(id)
        .get()
        .then(doc => {
          const data = {
            id: doc.id,
            firstName: doc.data().firstName,
            lastName: doc.data().lastName,
            posteName: doc.data().posteName,
            phone: doc.data().phone,
            accessLevel: doc.data().accessLevel,
            employeeId: doc.data().employeeId,
            employeeNumber: doc.data().employeeNumber,
            email: doc.data().email,
            role: doc.data().accessLevel,
            imageUrl: doc.data().imageUrl,
            avatar: {
              src: doc.data().imageUrl,
              size: 36
            }
          };
          if (data.role === 'Admin') {
            data.cardBgImage = '/static/bg/15.jpg';
          }
          this.$store.commit('currentEmployee', data);
          this.$router.push('/modifiers/employeeprofile');
          this.loading = false;
        });
    },
    deleteEmployee (id) {
      if (confirm(this.$t('emp._delete_confirm_'))) {
        this.$store.dispatch('deleteEmployee', id);
        alert(this.$t('emp._confirm_delete_emp_'));
      }  
    }  
  },
};
</script>

<style lang="stylus" scoped>
  .caption, .subheading {
    font-weight:200;  
  }
</style>


// WEBPACK FOOTER //
// src/components/widgets/card/NameCard.vue